import React from "react";
import { ICellRendererParams } from "ag-grid-community";

export const customValidationCellRenderer = (props: ICellRendererParams) => {
  const cellValue = props.value;
  return (
    <div id={`custom-cell-${props.data.id || props.data.key}-${props.colDef?.field}`} className="custom-validation-cell-renderer">
      <span>{cellValue}</span>
    </div>
  );
};
